var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"boxf"},[_vm._v("CopyRight @ 山东大课堂 2021")])}
var staticRenderFns = []

export { render, staticRenderFns }